// src/components/scan/header/ScanHeaderMobile.tsx
import { useTranslation } from 'react-i18next';

interface Props {
  domain: string;
  loading: boolean;
}

export default function ScanHeaderMobile({ domain, loading }: Props) {
  const { t } = useTranslation();

  return (
    <div className="text-center mb-10 px-4">
      <h1 className="text-3xl font-extrabold mb-4 text-white leading-tight">
        {t('scan.title')}
      </h1>
      <p className="text-base text-textLight max-w-md mx-auto">
        {loading ? `Realizando scan de ${domain}…` : t('scan.subtitle')}
      </p>
    </div>
  );
}
